import { Popup } from '@quickmd-llc/design-system'
import successIcon from '../../../images/common/success.png'
import { INVITATION_SENT_TEXT } from '../../../utils/constants'

type Props = {
  isOpen: boolean
  onClose: () => void
}

/**
 * "Invitation sent" success popup shown after a successful resend-invite. Replaces the legacy
 * `ui_kit_qmd` `PopUp` (rendered conditionally on `resendInviteSuccess`). Per POPUP rules it now
 * stays mounted and toggles `isOpen`; it auto-dismisses after 2s (timer owned by the orchestrator,
 * preserving the original behavior). `lockOpen` keeps it close-only via the timer, matching the
 * original which had no manual dismiss affordance.
 */
export function ResendInviteSuccessPopup({ isOpen, onClose }: Props) {
  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      lockOpen
      body={
        <div className='flex flex-col items-center'>
          <img src={successIcon} alt='Success' className='mx-auto mt-sp-7 h-[104px] w-[104px]' />
          <span className='mt-sp-7 h-[28px] w-full text-center text-2xl font-bold leading-[28px] tracking-[0.05em] text-text-dark'>
            {INVITATION_SENT_TEXT}
          </span>
        </div>
      }
    />
  )
}
